import { source } from "common-tags";
import { buildTypeName } from "./buildTypeName.js";
import { buildFieldProperties } from "./buildFieldProperties.js";
import { getHumanReadableModelName } from "./getHumanReadableModelName.js";
function buildCustomTypeDataType(args) {
  let code = "";
  const auxiliaryTypes = [];
  const contentTypeNames = [];
  const name = buildTypeName(args.model.id, "Document", "Data");
  const humanReadableName = getHumanReadableModelName({
    name: args.model.id,
    model: args.model
  });
  let fieldProperties = "";
  for (const tabName in args.model.json) {
    const { uid: _uid, ...fields } = args.model.json[tabName];
    const tabFieldProperties = buildFieldProperties({
      fields,
      fieldConfigs: args.fieldConfigs,
      path: [
        {
          name: args.model.id,
          model: args.model
        }
      ],
      tabName
    });
    fieldProperties += tabFieldProperties.code;
    auxiliaryTypes.push(...tabFieldProperties.auxiliaryTypes);
    contentTypeNames.push(...tabFieldProperties.contentTypeNames);
  }
  if (fieldProperties) {
    code = source`
			/**
			 * Content for ${humanReadableName} documents
			 */
			interface ${name} {
				${fieldProperties}
			}
		`;
  } else {
    code = `interface ${name} {}`;
  }
  return {
    name,
    code,
    auxiliaryTypes,
    contentTypeNames
  };
}
export {
  buildCustomTypeDataType
};
//# sourceMappingURL=buildCustomTypeDataType.js.map
